import request from '@/utils/request'
export function helpSort(data){
  return request({
    url: "/v1/helpcenterV/sort",
    method: 'post',
    data
  })
}
// 根据Id查看未解决问题统计图
export function getProblemThechart(params){
  return request({
    url: `/v1/feedbackV/count/` + params,
    method: 'GET',
  })
}
//根据问题Id查询原因说明文本分页
export function getProblemInfoList(params){
  return request({
    url: "/v1/feedbackV/text",
    method: 'GET',
    params
  })
}
//批量修改问题为热词
export function updateHotWord(data){
  return request({
    url: "/v1/issueV/updateHotWord",
    method: 'POST',
    data
  })
}
//根据id找绑定的问题
export function helpcenterInfo(params){
  return request({
    url: "/v1/helpcenterV/" + params,
    method: 'GET',
    params
  })
}
export function getTreeUp(params){
  return request({
    url: "/v1/classifyV/showtree1",
    method: 'GET',
    params
  })
}
//分类批量上下架
export function classUp(params){
  return request({
    url: "/v1/classifyV/updState",
    method: 'POST',
    params
  })
}
//服务中心批量上下架
export function helpUpState(params){
  return request({
    url: "/v1/helpcenterV/updState",
    method: 'POST',
    params
  })
}
// 修改服务中心
export function editelpCenter(params) {
  return request({
    url: "/v1/helpcenterV",
    method: 'PUT',
    params
  })
}
//添加服务中心
export function addHelpCenter(params) {
  return request({
    url: "/v1/helpcenterV",
    method: 'post',
    params
  })
}
//删除服务中心
export function delHelpCenter(params){
  return request(({
    url:"/v1/helpcenterV/" + params,
    method:"DELETE",
    params
  }))
}
//获取前端页面展示管理数据
export function getHelpCenterList(params) {
  return request({
    url: "/v1/helpcenterV/list",
    method: 'get',
    params
  })
}
//问题类别上下移
export function problemTypeSort(params) {
  return request({
    url: "/v1/classifyV/move",
    method: 'POST',
    params
  })
}
export function problemStateUp(params) {
  return request({
    url: "/v1/issueV/updState",
    method: 'POST',
    params
  })
}
//添加分类 判断是否有问题 true 可以 flase 不可以
export function ProblemAddJudgment(params) {
  return request({
    url: "/v1/classifyV/isClassify",
    method: 'POST',
    params
  })
}
// 添加 问题 判断是否有分类 true 可以 flase 不可以
export function JudgmentAddProblem(params) {
  return request({
    url: "/v1/issueV/isInsert",
    method: 'POST',
    params
  })
}
// 根据分类classify_id查询
export function classifyIdSearch(params) {
  return request({
    url: "/v1/issueV/",
    method: 'get',
    params
  })
}
//问题排序
export function problemSort(data) {
  return request({
    url: "/v1/issueV/sort",
    method: 'post',
    data
  })
}
//根据id获取问题类型
export function getProblemTypeInfo(params) {
  return request({
    url: "/v1/classifyV/" + params,
    method: 'get',
    params
  })
}
//修改问题类型
export function editProblemType(data) {
  return request({
    url: "/v1/classifyV",
    method: 'PUT',
    data
  })
}
//批量删除问题类型
export function delProblemType(params) {
  return request({
    url: '/v1/classifyV/' + params,
    method: 'DELETE',
    params
  })
}
// 新增问题分类
export function addProblemClassification(params) {
  return request({
    url: '/v1/classifyV',
    method: 'post',
    params
  })
}
//编辑问题
export function editProblemInfo(data) {
  return request({
    url: '/v1/issueV',
    method: 'post',
    data
  })
}
// 根据id获取问题详情
export function ProblemInfo(params) {
  return request({
    url: '/v1/issue/getIssueV/' + params,
    method: 'get',
    params
  })
}
// 删除问题
export function delProblem(params) {
  return request({
    url: '/v1/issueV/' + params,
    method: 'DELETE',
    params
  })
}
//新增问题
export function addProblem(data) {
  return request({
    url: '/v1/issueV/addServiceIssue',
    method: 'post',
    data
  })
}
// 树形
export function getTree(params) {
  return request({
    url: '/v1/classifyV/showtree',
    method: 'get',
    params
  })
}
// 问题列表
export function getProblem(params) {
  return request({
    url: '/v1/issueV/list',
    method: 'get',
    params
  })
}
//GET根据Id获取问题类型详细信息
export function getProblemInfo(params) {
  return request({
    url: '/v1/classifyV/' + params,
    method: 'get',
  })
}
